/**
 * Camada única do que abre POR CIMA do editor de workflows.
 *
 * Números medidos no editor em 21/09/2026: confirmação e `Modal` do sistema em
 * `z-[60]`, Tooltip em `z-[100]`, menu suspenso em `z-[101]`, painel do nó e
 * seletor de nós em `z-[200]`/`z-[201]`, folha inferior do celular em
 * `z-[530]`. Uma caixa que precisa aparecer SOBRE o painel do nó tem de passar
 * de 201 sem chegar a 530.
 *
 * **Por que 320 e não 300 (medido em 22/09/2026, Fase 4b):** o dropdown do
 * `MultiSelect` também é portaled ao body e fica em `z-[300]` (véu) /
 * `z-[301]` (painel), justamente para não sumir atrás do painel do nó. Com a
 * camada do editor em 300, uma confirmação aberta a partir de uma escolha
 * DENTRO desse dropdown nascia ATRÁS dele — e o painel de 288px cobria os
 * botões "Remover"/"Cancelar". Foi o que aconteceu ao apagar a última regra da
 * aba Cancelamento do Aguardar. 320 passa do dropdown e continua longe da
 * folha inferior do celular.
 *
 * É CLASSE, e não estilo, de propósito — mas NÃO porque classe vença estilo
 * inline: em CSS é o contrário, o `style` inline ganha da classe (só um
 * `!important` na classe inverteria isso). O motivo verdadeiro é que nos dois
 * componentes que usam esta constante o empilhamento NUNCA esteve no `style`
 * inline: o véu do `Modal` leva no `style` apenas `backgroundColor` e
 * `backdropFilter`, e o da confirmação apenas `backgroundColor` — o `z-index`
 * mora só na classe. Trocar a classe é, portanto, mexer no único lugar onde
 * esse valor existe, sem disputa com nada.
 *
 * O Tailwind gera essa classe porque o `content` declarado no
 * `tailwind.config.js` varre também os arquivos `.ts` de `src`.
 */
export const EDITOR_OVERLAY_Z_CLASS = 'z-[320]';
